import { render, staticRenderFns } from "./CriterionScaleEditor.vue?vue&type=template&id=753aabac&scoped=true"
import script from "./CriterionScaleEditor.vue?vue&type=script&lang=ts"
export * from "./CriterionScaleEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753aabac",
  null
  
)

export default component.exports